import * as React from 'react';
import { AuthProvider, useAuth } from './services/cognito';
import Dashboard from './components/dashboard/Dashboard';
import AuthContainer from './components/auth/AuthContainer';
import { CircularProgress, Box } from '@mui/material';

function AppContent() {
  const { isAuthenticated, initialized } = useAuth();

  if (!initialized) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? <Dashboard /> : <AuthContainer />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
